var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPollIconForIntroScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 185.185,
    height: 150.015,
    viewBox: "0 0 185.185 150.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.818,
    y1: -1.695,
    x2: 1.822,
    y2: 2.7,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    transform: "translate(-99.366 -294.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M492.084,2712c0-.359-.6-.711-1.2-.711H482.23c-.606,0-1.146.352-1.146.711v22.046c0,.359.54.836,1.146.836h8.652c.606,0,1.2-.477,1.2-.836Z",
    transform: "translate(-361.949 -2300.285)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M1575.824,2088.85h-8.544c-.6,0-1.1.691-1.1,1.523v50.952c0,.832.5,1.708,1.1,1.708h8.544c.6,0,1.359-.876,1.359-1.708v-50.952A1.568,1.568,0,0,0,1575.824,2088.85Z",
    transform: "translate(-1417.866 -1708.85)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 11,
    height: 64.922,
    rx: 5.5,
    transform: "translate(130.256 369)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M2808.736,1318.088a1.4,1.4,0,0,0-1.219-1.456h-8.652a1.338,1.338,0,0,0-1.129,1.456v88.729c0,.8.521,1.584,1.129,1.584h8.652c.607,0,1.219-.783,1.219-1.584Z",
    transform: "translate(-2595.238 -973.632)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 11,
    height: 75.173,
    rx: 5.5,
    transform: "translate(166.377 359)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 11,
    height: 87.214,
    rx: 5.5,
    transform: "translate(184.438 347)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260",
    transform: "translate(99.366 294.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M724.4,455l-.319,0a29.323,29.323,0,0,0-29.162,29.482H724.4Z",
    transform: "translate(-692.098 -455)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M1222.845,485.509l15.887-24.839a29.343,29.343,0,0,0-15.5-4.64c-.18,0-.359,0-.539,0Z",
    transform: "translate(-1190.675 -455.971)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M1227.813,563.751l29.451,1.322c.008-.185.015-.37.02-.555a29.464,29.464,0,0,0-13.585-25.606Z",
    transform: "translate(-1195.515 -534.269)",
    fill: "#ffa431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M673.124,1024.073l-29.1-1.013a29.493,29.493,0,0,0,20.7,29.179l8.551-27.964A.157.157,0,0,0,673.124,1024.073Z",
    transform: "translate(-644.002 -991.633)",
    fill: "#ea4549"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M1090.932,987.061l-7.894,28.355a26.134,26.134,0,0,0,7.333,1.068,29.491,29.491,0,0,0,27.958-18.532Z",
    transform: "translate(-1058.749 -957.626)",
    fill: "#db3239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M1255.431,997.87a29.39,29.39,0,0,0,2.159-9.82h0l-29.45-1.353Z",
    transform: "translate(-1195.824 -957.282)",
    fill: "#ffba3b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(206.453 388.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M2493.531,2187.493c-7.5,3.323-27.4,14.822-36,45.817,0,0,11.6.194,20.295-18.4,7.44-15.9,11.719-22.327,16.274-26.557A.522.522,0,0,0,2493.531,2187.493Z",
    transform: "translate(-2457.532 -2187.445)",
    fill: "#9ec266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M2486.85,2351.612s.014-.044.04-.13.067-.213.123-.378c.108-.33.274-.812.5-1.42s.509-1.341.845-2.179.745-1.77,1.2-2.784.978-2.1,1.547-3.237,1.2-2.328,1.879-3.538l.515-.916.539-.92c.358-.619.741-1.234,1.123-1.856s.786-1.237,1.185-1.859.812-1.238,1.235-1.848.835-1.226,1.278-1.818l.652-.894c.218-.3.444-.586.664-.877l.662-.867.674-.845c.439-.566.9-1.1,1.352-1.633s.9-1.043,1.35-1.542.891-.981,1.333-1.441c.221-.23.435-.46.654-.68l.652-.643.629-.622c.207-.2.419-.392.622-.583.414-.373.8-.742,1.184-1.072l1.094-.937.254-.216.253-.2.48-.376.844-.663,1.658-1.182a.124.124,0,0,1,.153.194l0,0-1.533,1.319-.785.719-.445.408-.235.215-.236.231-1.021.992c-.36.348-.717.738-1.1,1.13-.19.2-.391.395-.584.6l-.591.644-.61.665c-.2.227-.4.466-.611.7l-.628.722c-.216.24-.418.5-.631.75-.422.509-.857,1.024-1.277,1.568l-.642.815c-.216.274-.424.557-.64.837l-.646.847-.635.87c-.211.292-.427.583-.636.879l-.625.9c-.42.6-.826,1.207-1.24,1.811s-.8,1.224-1.207,1.833-.78,1.231-1.158,1.845c-.752,1.232-1.489,2.445-2.177,3.636l-1.015,1.753c-.329.573-.643,1.141-.951,1.691-.608,1.1-1.192,2.146-1.7,3.123-.528.967-.992,1.865-1.407,2.66s-.767,1.493-1.062,2.066l-.908,1.811v0a.124.124,0,0,1-.229-.093Z",
    transform: "translate(-2485.464 -2307.503)",
    fill: "#fff",
    opacity: 0.51
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217",
    transform: "translate(204.973 418.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M2461.958,2789.252s3.118-12.228,20.176-13.872c11.383-1.1,15-3.881,16.064-5.105a.188.188,0,0,1,.328.15c-.354,2.308-2.274,9.441-12.611,13.608C2473.458,2789.054,2467.216,2785.106,2461.958,2789.252Z",
    transform: "translate(-2461.958 -2770.209)",
    fill: "#9ec266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M2480.163,2890.359s.094-.1.278-.286.458-.449.822-.769.814-.7,1.348-1.114,1.156-.858,1.85-1.32,1.473-.924,2.32-1.375a28.139,28.139,0,0,1,2.74-1.274,24.182,24.182,0,0,1,3.087-1,22.567,22.567,0,0,1,3.315-.579c.282-.021.563-.054.846-.064l.847-.031.845.012c.281.007.56.033.838.05l1.589.1c.537.052,1.025.02,1.524.031l.37,0h.184l.184-.012.728-.051.358-.025.178-.012c.059-.007.116-.017.174-.025l.687-.1a13.769,13.769,0,0,0,2.5-.608,2.377,2.377,0,0,0,.275-.1l.267-.108c.175-.075.354-.135.515-.217l.471-.242c.076-.04.154-.076.226-.118l.208-.131.4-.249c.124-.087.239-.177.353-.259a7.092,7.092,0,0,0,.595-.494c.166-.163.317-.31.438-.445s.222-.255.292-.358.13-.179.165-.233a.938.938,0,0,0,.05-.08.091.091,0,0,1,.167.073h0s-.013.037-.042.1a3.012,3.012,0,0,1-.136.27,6.078,6.078,0,0,1-.652.938,7.679,7.679,0,0,1-.564.592c-.109.1-.221.209-.342.317l-.395.307-.209.161c-.073.051-.15.1-.227.147l-.477.3c-.164.1-.345.185-.524.282s-.362.2-.56.277a14.449,14.449,0,0,1-2.6.844l-.723.149c-.061.012-.122.026-.184.037l-.186.023-.376.047-.765.1-.194.023-.2.01-.4.02c-.529.022-1.085.065-1.605.035l-.8-.021-.818-.028a19,19,0,0,0-3.159.1,23.739,23.739,0,0,0-3.123.56,29,29,0,0,0-2.956.9,40.5,40.5,0,0,0-5.039,2.252c-.722.375-1.364.755-1.938,1.086s-1.062.646-1.466.9-.715.466-.927.61l-.323.223a.092.092,0,0,1-.127-.024A.091.091,0,0,1,2480.163,2890.359Z",
    transform: "translate(-2479.283 -2873.699)",
    fill: "#fff",
    opacity: 0.51
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 11,
    height: 49.627,
    rx: 5.5,
    transform: "translate(112.195 385)",
    fill: "#ffba3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(104.471 355.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M2229.908,1379.195l23.278-41.031h-4.77a.954.954,0,0,1-.8-1.567l24.81-27.821a1.768,1.768,0,0,1,3.1,1.116l-1.744,27.205a2.892,2.892,0,0,1-3.285,2.541l-3.325-.35-23.1,46.02a3.711,3.711,0,0,1-3.339,1.965h-8.005Z",
    transform: "translate(-2151.711 -1308.184)",
    fill: "#db3239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M1807.293,2183.605l16.434,33.587a6.073,6.073,0,0,0,5.495,3.269h8.472A3.147,3.147,0,0,0,1840.4,2219l.3-.5h0a2.455,2.455,0,0,1-2.157-1.215l-21.9-39.473Z",
    transform: "translate(-1748.342 -2141.371)",
    fill: "#ea4549"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M1134.1,2092.581h0a3.792,3.792,0,0,0-5.219.763l-24.162,33.4a10.707,10.707,0,0,1-8.689,4.282h-3.4l-2.767-7.334s22.462-31.689,28.252-36.482c0,0,5.766-4.781,11.451-1.166a8.892,8.892,0,0,1,3.338,3.871Z",
    transform: "translate(-1063.585 -2052.157)",
    fill: "#db3239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M512.794,2421.858a18.7,18.7,0,0,1,11.882-5.375s3.722,1.167,11.138,13.393,12.338,17.8,18.115,14.756l-.478.73a8.892,8.892,0,0,1-7.462,3.879h-3.195a11.252,11.252,0,0,1-8.873-4.183C528.149,2437.678,516.34,2423,512.794,2421.858Z",
    transform: "translate(-512.794 -2370.046)",
    fill: "#ea4549"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270",
    transform: "translate(234.594 298.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M-56.147,258.947a14.741,14.741,0,0,1-.646,2.857,1.2,1.2,0,0,0,1,.48",
    transform: "translate(81.026 -247.52)",
    fill: "#ffb392"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(0 22.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M-36.158,272.2l4.852,21.316a1.02,1.02,0,0,1-.85,1.236l-15.105,2.169a1.019,1.019,0,0,1-1.14-.782l-4.853-21.317a1.02,1.02,0,0,1,.85-1.236l15.106-2.169A1.02,1.02,0,0,1-36.158,272.2Z",
    transform: "translate(53.279 -271.408)",
    fill: "#ffa431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M-37,273.017l4.646,20.41-15,2.154L-52,275.17Z",
    transform: "translate(53.178 -271.535)",
    fill: "#fffaf1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(2.766 3.308)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    y1: 1.83,
    x2: 12.746,
    transform: "translate(0)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    y1: 1.83,
    x2: 12.746,
    transform: "translate(0.429 1.929)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    y1: 1.144,
    x2: 7.965,
    transform: "translate(5.736 4.215)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    y1: 1.144,
    x2: 7.965,
    transform: "translate(6.302 5.873)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    y1: 1.144,
    x2: 7.965,
    transform: "translate(6.868 7.531)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    y1: 1.144,
    x2: 7.965,
    transform: "translate(3.947 16.694)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.574,
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M-53.123,294.874a6.606,6.606,0,0,1-2.1-1.872l-1.8-2.144a1.782,1.782,0,0,1-.512-.956c1.006-.082,1.654,1.225,2.661,1.3a21.069,21.069,0,0,0-2-4.749,1.459,1.459,0,0,1-.288-1.182,7.668,7.668,0,0,1,2.795,2.041,14.866,14.866,0,0,1,1.515,1.928,20.745,20.745,0,0,1,2.71,6.659",
    transform: "translate(76.056 -249.611)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266",
    transform: "translate(26.905 53.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M-74.215,313.569l10.786-9.1s5.019,6.808,3.128,13.376c-.93,3.229-2.1,4.83-2.6,6.363-.473,1.431-3.72,21.7-3.478,23.178s1.986,5.628,2.65,9.987c.8,5.244.665,22.327,1.285,26.857s-3.563,5.3-3.793,3.763c-1.966-13.1-7.159-33.509-7.886-40.057S-74.557,329.4-74.215,313.569Z",
    transform: "translate(74.575 -304.469)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M-63.732,328.373l4.69,10.763a24.115,24.115,0,0,0-3.273,11.281c-.078,2.077.1,4.157.047,6.235a2.048,2.048,0,0,1-.063.451c-.629-3.078-1.1-5.616-1.281-7.269-.513-4.626-.516-11.98-.353-21.474A2.176,2.176,0,0,1-63.732,328.373Z",
    transform: "translate(64.06 -306.366)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M-68.947,390.545s1,4.752.734,5.358a8.331,8.331,0,0,1-2.237,3c-1.044.667-3.356,1.461-3.542,1.751a.717.717,0,0,0,.133.97,4.787,4.787,0,0,0,3.3.836c3.136-.517,3.46-1.9,5.286-2.126.316-.039.9.428,1.772-.018a2.074,2.074,0,0,0,1.222-2.012,8.995,8.995,0,0,0-1.388-3.356c-.523-.968-.892-5.4-.892-5.4",
    transform: "translate(76.555 -311.226)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M-74.424,402.388c-.228-.391-.286-.983-.074-1.128a18.368,18.368,0,0,1,1.952-1.175c.609-.28,1.572-.527,1.233-.342s.285.869.855.834c1.965-.12,3.414-1.426,4.534-1.706a3.845,3.845,0,0,0,2.363-2.621,7.547,7.547,0,0,1,1.161,2.213,3.879,3.879,0,0,1,.239,1.689,3.93,3.93,0,0,0-.18,1.61,3.082,3.082,0,0,1-1.162.419,4.58,4.58,0,0,1-1.25.018l-.139-1.014a4.6,4.6,0,0,0-1,.1,5.431,5.431,0,0,0-1.526.713c-.225.268-.4.756-.7.906a6.255,6.255,0,0,1-2.578.643C-72.8,403.669-74.034,403.057-74.424,402.388Z",
    transform: "translate(76.876 -311.758)",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(12.133 52.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M-70.421,394.811c.232-.256,2.73-.662,3.9-1.152a6.743,6.743,0,0,0,2.732-2.6,28.1,28.1,0,0,0,.169-5.216c-.234-9.326-1.957-32.117-2.207-37.575-.434-9.488.8-19.279,4.447-34.509l13.593-10.43s3.806,7.076,2.532,13.842c-.739,3.925-4,4.528-4.546,6.055s-8.773,26.122-8.773,26.122a46.314,46.314,0,0,1,1.692,11.144c.079,4.973-2.175,19.974-2.594,25.69-.049,1.117-.241,3.79.087,4.641.4,1.043,1.432,2.268,1.38,3.584a2.024,2.024,0,0,1-1.545,1.789c-.963.3-1.5-.258-1.831-.272-1.916-.079-2.447,1.239-5.755,1.238a5.241,5.241,0,0,1-3.285-1.366A.7.7,0,0,1-70.421,394.811Z",
    transform: "translate(70.824 -303.326)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M-56.77,403.6c-.18-.424-.156-1.019.083-1.127a18.9,18.9,0,0,1,2.181-.842c.667-.178,1.7-.263,1.32-.137s.172.906.764.965c2.045.2,3.725-.852,4.92-.946a3.139,3.139,0,0,0,2.474-2.2,7.887,7.887,0,0,1,1.22,2.378,3.738,3.738,0,0,1,.009,1.71,3.731,3.731,0,0,0-.413,1.562,3.265,3.265,0,0,1-1.258.225A5,5,0,0,1-46.764,405v-1.026a4.967,4.967,0,0,0-1.045-.066,3.457,3.457,0,0,0-1.685.6c-.282.212-.577.568-.909.651a6.94,6.94,0,0,1-2.684.2C-55.278,405.132-56.461,404.326-56.77,403.6Z",
    transform: "translate(56.888 -310.949)",
    fill: "#2f2f2f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M-54.327,303.137c.922,1.013,4.21,6.49,4.245,10.948a20.588,20.588,0,0,1-1.694,8.248c-.841,2.436-2.407,4.616-2.407,5.061s-2.451.754-7.65.427c-9.606-.6-13.136-2.407-13.136-2.407a75.247,75.247,0,0,1,.671-12.667c.468-4.118,3.974-10.638,3.974-10.638",
    transform: "translate(92.092 -250.948)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M-61.334,283.808s-1.548,7.688-1.953,9.056-2.413,10.055-4.316,9.9-12.323-8.85-12.323-8.85l1.476-2.951,9.173,4.373s.829-9.93,1.555-12.3",
    transform: "translate(107.864 -249.434)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M-66.032,289.015c-.971,3.432-2.962,7.05-3.556,9.71-.12.535-6.471-1.775-6.486-4.16",
    transform: "translate(109.016 -249.908)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M-78.611,272.3a11.277,11.277,0,0,1,4.584,1.5c3.933,3.009.889,13.931.889,13.931s.194.583-2.446.435a18.979,18.979,0,0,1-4.757-.9l.763-8.95",
    transform: "translate(118.928 -248.581)",
    fill: "#db3239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M-74.023,279.017s.333,6.42-.829,9.661a10.516,10.516,0,0,1-2.154-.283Z",
    transform: "translate(117.821 -249.114)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M-70.827,250.357c-1.833,2.376-1.47,5.719-1.018,8.685q.342,2.249.686,4.5a3.016,3.016,0,0,0,.808,1.952,3.014,3.014,0,0,0,2.086.424q-.011,1.861-.022,3.724,3.186.077,6.372.026a6.131,6.131,0,0,1,.551-2.529c1.038-.02,1.733-1.062,2.139-2.019a29.188,29.188,0,0,0,1.142-3.407,18.887,18.887,0,0,0,.9-4.672,6.764,6.764,0,0,0-1.348-4.472,8.136,8.136,0,0,0-2.59-1.934c-1.317-.688-2.9-1.23-4.258-.629",
    transform: "translate(96.607 -246.79)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M-73.109,261.423a3.879,3.879,0,0,0-.175-2.784,1.842,1.842,0,0,0-.559-.706,1.179,1.179,0,0,0-1.135-.118,1.253,1.253,0,0,0-.57.532,16.26,16.26,0,0,1-.4-5.2,6.768,6.768,0,0,1,4.293-5.893c4.5-1.849,10.963-.023,12.791,4.394a10.926,10.926,0,0,1-1.962,10.946c-2.339,2.475-5.7,2.839-8.808,2.329-1.589-.261-4.04-.1-4.863-2.265a.241.241,0,0,1,.248-.32C-73.6,262.384-73.155,261.653-73.109,261.423Z",
    transform: "translate(101.086 -246.535)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M-60.629,255.627c-.168.261-.128.614-.284.882a2.078,2.078,0,0,1-1.088.833c-.763.354-.585,1.466-.562,1.963-.576-.383-.669-1.426-.809-1.955-.156-.595-.256-1.205-.429-1.794a9.131,9.131,0,0,1-.515-1.719,7.059,7.059,0,0,1,2.7-5.709,3.757,3.757,0,0,1,4.21.05,3.278,3.278,0,0,1,1.2,1.528,1.014,1.014,0,0,1,.047.82",
    transform: "translate(88.261 -246.612)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M-57.7,272.132c-.108-.727-.3-1.575-.981-1.862a2.129,2.129,0,0,0-.6-.126,49.272,49.272,0,0,0-6.243-.295,5.8,5.8,0,0,0-2.526.443A6.217,6.217,0,0,0-70.5,273.42",
    transform: "translate(95.553 -248.386)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M-76.558,298.893a17.194,17.194,0,0,0,1.2-1.413,22.11,22.11,0,0,0,.881-7.114c-.212-1.3-1.367-2.007-1.888-4.91a10.744,10.744,0,0,1,1.721-7.895c1.212-1.761.493-1.751.909-3.909a2.053,2.053,0,0,1,.428-1.074,10.323,10.323,0,0,1,2.424-1.148c3.369-.522,5.35-.115,8.756.034a29.167,29.167,0,0,1,5.023.636c1.831.4,3.426.889,3.8,3.374a25.037,25.037,0,0,1-1.076,11.374c-.774,2.416-5.4,10.774-4.252,12.391a5.53,5.53,0,0,1,1,1.534c.29,1.689-3.527,2.283-5.16,2.417a63.837,63.837,0,0,1-7.84-.05c-1.89-.088-6.024-.748-6.318-3.084A1.689,1.689,0,0,1-76.558,298.893Z",
    transform: "translate(96.861 -248.491)",
    fill: "#db3239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M-58.177,287.087a6.718,6.718,0,0,0,.5,1.949,5.22,5.22,0,0,0,3.433.156,49.9,49.9,0,0,1,1.551-6.568S-58.176,286.459-58.177,287.087Z",
    transform: "translate(79.199 -249.401)",
    fill: "#b03d44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269",
    transform: "translate(4.471 25.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M-39.134,285.312s-6.224,15.041-8.924,15.041c-1.965,0-6.781-13.885-6.781-13.885l3.043-1.441,3.393,5.815L-44.966,280",
    transform: "translate(58.098 -274.227)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M-34.835,285.841a5.923,5.923,0,0,1-.935-2.715,11.48,11.48,0,0,0,.07-2.877,11.9,11.9,0,0,0-1.017-1.974c-.292-.256-1.374-.667-1.638-.484s-.594-.658-1.032-.585a.929.929,0,0,0-.8.84c0,.4-.585.475-.658.768a4.148,4.148,0,0,1-.146.767c-.11.22-.433.111-.548.658-.106.5.036.549,0,.8s-.256.233-.183.72a6.123,6.123,0,0,0,.7,1.667,4.829,4.829,0,0,0,1.7,1.719,3.243,3.243,0,0,1,.991,1.367",
    transform: "translate(41.741 -274.005)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M-38.854,273.943a.373.373,0,0,1,.538-.145.479.479,0,0,1,.119.6l-1.84,4.165s-.148.171-.434-.079c-.308-.273-.21-.409-.21-.409S-38.93,274.062-38.854,273.943Z",
    transform: "translate(44.087 -273.729)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268",
    transform: "translate(3.064 4.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M-39.422,278.151A4.274,4.274,0,0,0-38.3,279.32c.286.27.25.443.566.72-.553-.041-.458-.368-1.176-.886a1.513,1.513,0,0,1-.741-.908.125.125,0,0,1,.228-.1Z",
    transform: "translate(39.652 -278.091)",
    fill: "#f2a181"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M-47.755,271.2c-1.621.084-6.34-.744-8.963,2-2.2,2.3-3.455,8.323-4.34,10.766,2.2,2.243,4.321,4.052,7.656,3.324.126-.094,1.78-5.3,2.985-5.764",
    transform: "translate(76.916 -248.489)",
    fill: "#db3239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M-72.277,322.576s-1.071,25.734-.875,27.61,2.283,37.406,2.283,37.406,4.287.751,6.855,0c0,0,3.312-27.669,0-36.29l1.472-8.261s-.219,6.145,0,7.4,6.846,36.28,6.846,36.28,4.383-.116,6.385-1.872c0,0,.624-24.337-3.942-34.574l4.179-26.779-2.407-6.814Z",
    transform: "translate(89.391 -252.105)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M-68.439,343.359c.612-3.958,4.389-18,4.55-18.333,2.065-1.6,3.951-3.01,4.638-4.344-1.128,3.385-3.3,3.56-4.113,5.312-2.008,4.325-.474,3.371-5.163,17.862",
    transform: "translate(95.288 -252.423)",
    fill: "#130f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M-72.852,270.441c.1,1.369-.183,2.737-.205,4.109a4.971,4.971,0,0,0,1.281,3.784c1.008.932,2.879.968,3.595-.2a5.421,5.421,0,0,1-3.936,2.832,8.326,8.326,0,0,1-4.9-.755,11.462,11.462,0,0,1-6.628-10.576c.1-3.674,2.893-7.225,6.79-5.293A7.506,7.506,0,0,1-72.852,270.441Z",
    transform: "translate(118.139 -247.905)",
    fill: "#282828"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollIconForIntroScreen);
export default __webpack_public_path__ + "static/media/Poll_Icon_For_Intro_Screen.aa95225630a5d8d30ee6829a0b8c5825.svg";
export { ForwardRef as ReactComponent };